// extracted by mini-css-extract-plugin
export default {"editOfferStep2Container":"JBLFDVW5kbuEzNU6or2d","targetFilterContainer":"IuBMPB812pmFKRasVV7N"};